<template>
  <div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Tambah COA'">
          <template v-slot:body>
            <Form
              :form="form"
              :route="'coas'"
            />
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue";
import Form from '@/component/masters/coas/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {

  data() {
    return {
      form: {
        name: '',
        number: '',
        coa_category_id: '',
        sub_ledger_id: '',
        cash_flow_id: '',
        description: ''
      },
    };
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "COA", route: "" },
      { title: "Daftar COA", route: "/coas/list" },
      { title: "Tambah" },
    ])
  },

}

</script>